import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Exact } from "@Helpers/types/exact";
import type { UserDetails } from "@ServerTypes/accounts/accounts.schema";

const initialState: UserDetails = {};

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    setUserDetails: (_state: UserDetails, action: PayloadAction<UserDetails>) => ({ ...action.payload }),
    updateUserDetails: (state: UserDetails, action: PayloadAction<Partial<UserDetails>>) => ({
      ...state,
      ...action.payload,
    }),
    resetUserDetails: () => initialState,
  },
});

const { setUserDetails: _setUserDetailsRaw, updateUserDetails: _updateUserDetailsRaw } = userDetailsSlice.actions;
export const { resetUserDetails } = userDetailsSlice.actions;

/**
 * Object-payload action creators are wrapped with `Exact<>` so excess properties
 * are caught even when the payload is passed through a variable.
 */
export const setUserDetails = <T extends Exact<UserDetails, T>>(payload: T) => _setUserDetailsRaw(payload);
export const updateUserDetails = <T extends Exact<Partial<UserDetails>, T>>(payload: T) =>
  _updateUserDetailsRaw(payload);

export default userDetailsSlice.reducer;
